import { useSaveEntryTemplate } from "@tandemdiabetes/sugarmate-api-react-client"
import { useUpdateCollectionItem } from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

export function useUpdateEntryTemplate() {
  return useUpdateCollectionItem(
    CollectionKey.EntryTemplate,
    "entry_template",
    useSaveEntryTemplate,
    (i) => i,
  )
}
